import { getMenuListApi } from '@/api/serviceEip'

/**
 * @description 菜单、导航
 * @date 2023-10-30 15:23:50
 * @author 2028
 */
export default {
  namespaced: true,
  state: {
    menuList: [], // 菜单数组
    curFirstMenu: '', // 选中的一级菜单
    curSecondMenu: '', // 当前菜单
    curTab: '', // 当前选中的标签
    tabList: '' // 打开的标签数组
  },
  getters: {
    secondMenuList(state) {
      return state.menuList.find((item) => item.id === state.curFirstMenu)?.children || []
    }
  },
  mutations: {
    setCurFirstMenu(state, menu) {
      state.curFirstMenu = menu
    },
    setCurSecondMenu(state, menu) {
      state.curSecondMenu = menu
    },
    setMenuList(state, menuList) {
      state.menuList = menuList
    },
    setCurTab(state, tab) {
      state.curTab = tab
    },
    setTabList(state, tabList) {
      state.tabList = tabList
    }
  },
  actions: {
    async getMenuList({ commit, state }, to) {
      const res = await getMenuListApi({
        menuAlias: 'manage_menu'
      })
      console.log(res)
      const list = Array.isArray(res.value) ? res.value : []
      commit('setMenuList', list)
      list.forEach((item) => {
        const menu = item.children?.find((item2) => {
          return item2.alias === to.params.pathMatch
        })
        if (menu) {
          commit('setCurFirstMenu', item?.id || '')
          commit('setCurSecondMenu', menu?.id || '')
        }
      })
    }
  }
}
